import { useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteBanner } from "../../apis";
import { DeleteBannerModalProps } from "./DeleteBannerModal.types";

const DeleteBannerModal = ({
  isOpen,
  onClose,
  onCloseParentModal,
  bannerId
}: DeleteBannerModalProps) => {
  const { t } = useTranslation();
  const refetchBanners = useRefetchQuery(["banners"]);

  const { mutate: mutateDeleteBanner, isLoading: isLoadingDeleteOffer } =
    useDeleteBanner({
      onSuccess: () => {
        refetchBanners();
        onClose();
        onCloseParentModal?.();
        toast.success(t("Banner was deleted successfully"));
      }
    });

  const onDeleteBanner = () => {
    if (bannerId) mutateDeleteBanner(bannerId);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      isLoading={isLoadingDeleteOffer}
      title="Delete Banner"
      okText="Delete"
      onClose={onClose}
      onOk={onDeleteBanner}
    >
      {t("Are you sure you want to delete this banner?")}
    </Modal>
  );
};

export default DeleteBannerModal;
